import { render, staticRenderFns } from "./ExtendsImageTabsContent.vue?vue&type=template&id=6876f93e&scoped=true&"
import script from "./ExtendsImageTabsContent.vue?vue&type=script&lang=ts&"
export * from "./ExtendsImageTabsContent.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendsImageTabsContent.vue?vue&type=style&index=0&id=6876f93e&lang=scss&scoped=true&"
import style1 from "./ExtendsImageTabsContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876f93e",
  null
  
)

export default component.exports